/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0fb4ccb7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0fb4ccb7&lang=scss&scoped=true"

import exportComponent from "/Users/kaopuai/rzd-project/rzd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb4ccb7"]])

export default __exports__